<template>
  <div class="sections-holder">
    <FaqSection>
      <span slot="heading">
        What is a standard normal distribution?
      </span>
      <div slot="content">
        <p>To answer the question, we first need to define what normal distribution is. Otherwise known as Gaussian distribution, it’s a symmetrical distribution with equal mean, median and mode. Many statisticians and mathematicians also refer to it as the Bell Curve because of its bell-like shape.</p>
        <p>The normal distribution is perfectly centered around its mean and it can be described by two values:</p>
        <ul>
          <li>The mean</li>
          <li>The standard deviation</li>
        </ul>
        <p>However, the two measures can take on any value. So, we need a way to compare different normal distributions that may have different means and standard deviations. And this is where standardization comes into play&#8212;this is the process of transforming a variable to one with a mean of 0 and a standard deviation of 1.</p>
        <p>Logically, a normal distribution can also be standardized; the result is called a standard normal distribution. The standardized variable is called a z-score and is equal to the original variable, minus its mean, and divided by its standard deviation.</p>
        <p>By standardizing the normal distribution, you can easily calculate the probability of certain values occurring. In addition, you can compare datasets with different means and standard deviations. This is useful in hypothesis testing and confidence intervals.</p>
      </div>
    </FaqSection>
    <hr>
    <FaqSection>
      <span slot="heading">
        What is a 95% confidence interval?
      </span>
      <div slot="content">
        <p>A 95% confidence interval implies we are 95% confident that the true population mean falls within this interval. Logically, the other 5% denotes the chance that true population mean is not located there.</p>
        <p>To calculate a 95% confidence interval, we use a point estimate of the population parameter (such as the sample mean or proportion), then add and subtract the appropriate critical value from the t-distribution (or z-distribution) times the standard error. The resulting range represents the plausible values for the population mean with 95% confidence.</p>
        <p>You can use our Confidence Interval Calculator to obtain values, including the 95% confidence interval.</p>
      </div>
    </FaqSection>
  </div>
</template>

<script>
import FaqSection from './Section.vue';

export default {
  components: {
    FaqSection,
  },
};
</script>

<style lang="scss" scoped>
.sections-holder {
  hr {
    margin: var(--spacing-8) 0 var(--spacing-24);
    border: 1px solid rgba(0, 12, 31, 0.12);
  }
}
</style>
